import './Sitemap.sass';
import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';
import { useRoutes, useArticles } from '../api';
import { Link } from 'react-router-dom';
import Meta from '../components/Meta';

const Sitemap = (props) => {
	const { routes } = useRoutes();
	const { breadcrumbs } = useArticles('', '/sitemap', '', '', '');

	return (
		<div className='Sitemap'>
			<Meta data={props.routeData} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='flex-wrap'>
					{routes.map((route) => {
						if (route.url === '/' || route.route === '/') return null;

						if (route.url === '/dividend' || route.route === '/dividend') {
							return (
								<Link to='/dividend' className='group' key={route.guid}>
									<div className='head'>
										<div className='text'>{route.name}</div>
										<div className='line'></div>
									</div>
								</Link>
							);
						}

						return (
							<div className='group' key={route.guid}>
								<div className='head'>
									<div className='text'>{route.name}</div>
									<div className='line'></div>
								</div>

								{route.categoryChild.map((child) => {
									return (
										<div className='link-wrap' key={child.guid}>
											<Link to={child.url || child.route} className='child'>
												<div className='text'>{child.name}</div>
											</Link>

											{child.name === '影音專區' &&
												child.categoryChild.map((grandChild) => {
													return (
														<div className='link-wrap' key={grandChild.guid}>
															<Link to={grandChild.url || grandChild.route} className='grandChild'>
																<div className='square'></div>
																<div className='text'>{grandChild.name}</div>
															</Link>
														</div>
													);
												})}
										</div>
									);
								})}
							</div>
						);
					})}

					<div className='group filler'></div>
					<div className='group filler'></div>
					<div className='group filler'></div>
				</div>
			</div>
		</div>
	);
};

export default Sitemap;
